<script setup lang="ts">
import { useConfigurator } from '@/composables/configurator/useConfigurator'

const { customerIntents } = useConfigurator()
</script>

<template>
  <CustomerIntents v-model="customerIntents" data-testid="ci-tab-content" />
</template>
